import { render, staticRenderFns } from "./airbersih.vue?vue&type=template&id=23336abf"
import script from "./airbersih.vue?vue&type=script&lang=js"
export * from "./airbersih.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports